import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const { resetPassword } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!email) {
      setError('Please enter your email address')
      return
    }

    setIsLoading(true)
    setError('')

    try {
      const result = await resetPassword(email)
      
      if (result.success) {
        setSuccess(true)
      } else {
        setError(result.error?.message || 'Failed to send reset email')
      }
    } catch (err) {
      setError('An unexpected error occurred')
    } finally {
      setIsLoading(false)
    }
  }

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-4">
        <div className="w-full max-w-sm text-center">
          <h2 className="text-lg font-semibold text-black mb-2">Check your email</h2>
          <p className="text-sm text-gray-500 mb-1">
            Password reset instructions have been sent to
          </p>
          <p className="text-sm font-medium text-black mb-6">{email}</p>

          <button
            type="button"
            onClick={onBackToLogin}
            className="w-full py-2.5 bg-black text-white text-sm font-medium rounded-md hover:bg-gray-900 transition-colors"
          >
            Back to sign in
          </button>

          <p className="mt-6 text-xs text-gray-400">
            Didn't receive the email? Check your spam folder.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h2 className="text-lg font-semibold text-black">Reset password</h2>
          <p className="text-sm text-gray-400 mt-1">
            Enter your email to receive reset instructions
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-xs font-medium text-gray-500 mb-1.5">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              disabled={isLoading}
              className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm text-black placeholder-gray-300 focus:outline-none focus:border-black transition-colors disabled:bg-gray-50 disabled:text-gray-400"
            />
          </div>

          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-2.5 bg-black text-white text-sm font-medium rounded-md hover:bg-gray-900 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Sending...' : 'Send reset instructions'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <button
            type="button"
            onClick={onBackToLogin}
            className="text-xs text-gray-400 hover:text-black transition-colors"
            disabled={isLoading}
          >
            Back to sign in
          </button>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
